import React,{useState} from 'react'
import './_navbar.scss'
import './_hamburguer.scss'
var Navbar=({content})=>{
	var [checked,setChecked]=useState(false)
	var list=
	<ul>
	<li><a href="#">product</a></li>
	<li><a href="#">features</a></li>
	<li><a href="#">princing</a></li>
	<li><a href="#">
	 <svg height="60" width="60">
  <circle cx="10" cy="10" r="3"  fill="red" />
</svg> 
	login
	</a></li>
	</ul>
	
	return(
	<nav>
	<img src="./images/logo.svg" alt="logo.svg"/>
	<div className="overlayDesktop">
		{list}
	</div>
	<div className="menu-wrap">
	<input type="checkbox" value="unchecked"  onChange={()=>setChecked(!checked)} className="toggler"/>
	<div className="hamburger"><div></div></div>
	<div className={checked?'overlay active':'overlay'}>
	{list}
	</div>
	</div>
	</nav>
	)
}

export default Navbar